module.exports = __webpack_public_path__ + "static/media/air-freshener.5e17c863.svg";